import { isMobile } from "@/util"
import { writable } from "svelte/store"

export const transpose = writable<boolean>(isMobile())

export const toggleTranspose = () =>
  transpose.update(($transpose) => !$transpose)
